module.exports = __webpack_public_path__ + "static/media/foreign-we-facility.b38fad51.jpg";